import clsx from 'clsx';

export const getInputClasses = ({
  disabled,
  error,
  focused,
}: {
  disabled?: boolean;
  error?: boolean | string;
  focused?: boolean;
}) => {
  const baseClasses = 'flex items-center gap-2 !outline-none rounded-[4px] border-base-300 bg-base-100';

  if (disabled) return clsx(baseClasses, 'cursor-auto opacity-40');
  if (error) return clsx(baseClasses, 'bg-error-content border-error focus-within:border-error');
  if (focused) return clsx(baseClasses, 'border-base-content/60');
  return clsx(baseClasses, 'focus-within:border-base-content/60');
};
